import { buildApiUrl } from '../utils/apiConfig';
import { MarketingHubNavItem, MarketingHubPage } from '../types/marketingHub';

export async function fetchMarketingHubNav(): Promise<MarketingHubNavItem[] | null> {
    try {
        const response = await fetch(buildApiUrl('api/cms/marketing-hub'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch Marketing Hub: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching Marketing Hub nav:', error);
        return null;
    }
}

export async function fetchMarketingHubPage(slug: string): Promise<MarketingHubPage | null> {
    const response = await fetch(
        buildApiUrl(`api/cms/marketing-hub/${encodeURIComponent(slug)}`),
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        }
    );

    if (response.status === 404) {
        return null;
    }

    if (!response.ok) {
        throw new Error(`Failed to fetch Marketing Hub page: ${response.status}`);
    }

    return await response.json();
}
